import React from "react";
import {Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";
import { updateStatusUser,fetchUsers } from "appRedux/actions/Users";

class ModalDelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      visible: false
    }
    }

    showModal = () => {
      this.setState({
        visible: true,
        status: 1,
      });
    };



  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El usuario ha cambiado su estado éxitosamente.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al eliminar el usuario.',
      });
    }
  };
  
 
  render() {

    let labelActionStatus;
    let userStatus;
    let classButtonName;
    let actionButton
    if(this.props.recording.user_status===1){
      labelActionStatus=<p>¿Está seguro de desactivar el usuario {this.props.recording.name}?</p>
        userStatus=0;
        classButtonName="icon icon-divider"
        actionButton="desactivar"
      }else{
        labelActionStatus=<p>¿Está seguro de activar el usuario {this.props.recording.name}?</p>
        classButtonName="icon icon-add"
        userStatus=1;
        actionButton="activar"
      
      }

    return (
      <div>
       <Button type="info" onClick={this.showModal}>{actionButton}</Button>
        <Modal
           okText = {actionButton}
          cancelText = "Salir"
          title="Estado de usuario"
            visible={this.state.visible}
            onOk={() => {
              console.log(this.props.recording.id)
              this.props.updateStatusUser(this.props.recording.id,userStatus, () => { this.props.fetchUsers( ); });
              this.onNotification('success');
            }}
            onCancel={() => {
              this.props.fetchUsers( );
              this.setState({visible: false});
            }}
          >
          {labelActionStatus}
        </Modal>
      </div>
    );
  }
}


function mapStateToProps({users}) {
  return {
    users
  }
}
export default connect(mapStateToProps, {fetchUsers, updateStatusUser} )(ModalDelete);


// WEBPACK FOOTER //
// ./src/routes/main/Admin/ModalDelete.js